
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

export const UBL_PAYMENT_MEANS_CODES = ["10", "20", "30", "31", "42", "48", "49", "54", "55", "58", "59", "68", "97"];

export default Vue.extend({
	props: {
		value: {
			type: String,
			default: ""
		},
		label: {
			type: [String, Object as ()=>TranslateResult]
		},
		emptyText: {
			type: [String, Object as ()=>TranslateResult]
		}
	},
	computed: {
		items():ISelectItem<string>[]{
			const result:ISelectItem<string>[] = [];
			if (this.emptyText) {
				result.push({text: this.emptyText as string, value: ""});
			}
			for (const code of UBL_PAYMENT_MEANS_CODES) {
				result.push({text: `${code} - ${this.$ct(`codes.${code}`)}`, value: code});
			}
			return result;
		}
	},
	methods: {
		onInput(value:string){
			this.$emit("input", value || "");
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default.payment-means-code-select"
	}
});
